import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { donutChartData } from '../MockData';

function SimpleDonutChart({ width, height }) {
  const options = {
    chart: {
      type: 'donut',
    },
    labels: donutChartData.labels,
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total',
              formatter: () => {
                // Example: show sum of series
                return donutChartData.series.reduce((a, b) => a + b, 0);
              },
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(1)}%`,
    },
    legend: {
      position: 'bottom',
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={donutChartData.series}
      type="donut"
      width={width}
      height={height}
    />
  );
}

export default SimpleDonutChart;
